module.exports = __webpack_public_path__ + "img/bg.7bb7c176.png";